import { GmailAnalyticsEnum } from '@workalizer/shared';
import { groupGmailAnalyticByPeriod } from '@workalizer/shared/utils';
import { groupBy } from '@workalizer/shared/utils';
import { format } from 'date-fns';
export var processGmailAnalytic = function (gmailAnalytics, dateFrom, dateTo) {
    // TODO: Simplify aggreagtion of this query
    var totalEmailsReceived = gmailAnalytics
        .filter(function (item) { return item.type === GmailAnalyticsEnum.GMAIL_EMAIL_RECEIVED; })
        .reduce(function (acc, item) { return acc + item.value; }, 0);
    var totalEmailsSent = gmailAnalytics
        .filter(function (item) { return item.type === GmailAnalyticsEnum.GMAIL_EMAIL_SENT; })
        .reduce(function (acc, item) { return acc + item.value; }, 0);
    var gmailAnalyticsGroupedByDate = groupBy(gmailAnalytics, 'date');
    var analytics = Object.entries(gmailAnalyticsGroupedByDate).map(function (_a) {
        var _b;
        var date = _a[0], items = _a[1];
        var emails = items.reduce(function (acc, item) {
            var type = item.type;
            acc[type] += item.value;
            return acc;
        }, (_b = {},
            _b[GmailAnalyticsEnum.GMAIL_EMAIL_RECEIVED] = 0,
            _b[GmailAnalyticsEnum.GMAIL_EMAIL_SENT] = 0,
            _b));
        var formattedDate = format(date, 'yyyy-MM-dd');
        return {
            date: formattedDate,
            emailsReceivedCount: emails[GmailAnalyticsEnum.GMAIL_EMAIL_RECEIVED],
            emailsSentCount: emails[GmailAnalyticsEnum.GMAIL_EMAIL_SENT]
        };
    });
    var groupedAnalyticByWeek = groupGmailAnalyticByPeriod(analytics, new Date(dateFrom), new Date(dateTo));
    var result = {
        totalEmailsReceived: totalEmailsReceived,
        totalEmailsSent: totalEmailsSent,
        analytics: groupedAnalyticByWeek
    };
    return result;
};
